/* Sock upsell for the cart drawer. Mirrors the theme's own cart-quantity flow:
   add to cart with bundled section rendering, re-render the drawer, then refresh the header count. */
if (!customElements.get('sock-upsell')) {
  class SockUpsell extends HTMLElement {
    constructor() {
      super();
      this.handleAdd = this.handleAdd.bind(this);
    }

    connectedCallback() {
      this.button = this.querySelector('[data-sock-add]');
      this.error = this.querySelector('[data-sock-error]');
      this.button?.addEventListener('click', this.handleAdd);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.handleAdd);
    }

    async handleAdd(event) {
      event.preventDefault();
      if (this.button.getAttribute('aria-busy') === 'true') return;
      this.button.setAttribute('aria-busy', 'true');
      if (this.error) this.error.hidden = true;

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{
              id: parseInt(this.dataset.variantId, 10),
              quantity: 1,
              properties: { _upsell: 'cart-drawer' }
            }],
            sections: 'cart-drawer'
          })
        });
        const data = await response.json();

        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'Sorry, we could not add the socks.');
        }

        window.eventBus?.emit('update:cart:drawer', data);
        this.updateCartCount();
      } catch (error) {
        console.error('Sock upsell:', error);
        if (this.error) {
          this.error.textContent = error.message;
          this.error.hidden = false;
        }
        this.button.removeAttribute('aria-busy');
      }
    }

    async updateCartCount() {
      try {
        if (!document.querySelector('[data-cart-count-indicator]') || !window.wetheme?.updateCartCount) return;
        const response = await fetch(`${window.routes.cart_url}?view=compare`);
        window.wetheme.updateCartCount(await response.json());
      } catch (error) {
        console.error('Sock upsell cart count:', error);
      }
    }
  }

  customElements.define('sock-upsell', SockUpsell);
}
